import { isObject } from './isObject';
const ABORT_ERROR_NAMES = new Set([
    'CanceledError',
    'AbortError'
]);
const ABORT_ERROR_CODES = new Set([
    'ERR_CANCELED'
]);
const TIMEOUT_ERROR_CODES = new Set([
    'ECONNABORTED',
    'ETIMEDOUT'
]);
const NETWORK_ERROR_CODE = 'ERR_NETWORK';
export const isAbortError = (err)=>isObject(err) && (typeof err.name === 'string' && ABORT_ERROR_NAMES.has(err.name) || typeof err.code === 'string' && ABORT_ERROR_CODES.has(err.code));
export const isTimeoutError = (err)=>isObject(err) && typeof err.code === 'string' && TIMEOUT_ERROR_CODES.has(err.code);
export const isNetworkError = (err)=>isObject(err) && err.code === NETWORK_ERROR_CODE;
